var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6875 9H14.3125C11.3789 9 9 11.3789 9 14.3125V20.6875C9 23.6211 11.3789 26 14.3125 26H20.6875C23.6211 26 26 23.6211 26 20.6875V14.3125C26 11.3789 23.6211 9 20.6875 9ZM24.4062 20.6875C24.4062 22.7381 22.7381 24.4062 20.6875 24.4062H14.3125C12.2619 24.4062 10.5938 22.7381 10.5938 20.6875V14.3125C10.5938 12.2619 12.2619 10.5938 14.3125 10.5938H20.6875C22.7381 10.5938 24.4062 12.2619 24.4062 14.3125V20.6875Z",
    fill: "#272830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.25C15.1529 13.25 13.25 15.1529 13.25 17.5C13.25 19.8471 15.1529 21.75 17.5 21.75C19.8471 21.75 21.75 19.8471 21.75 17.5C21.75 15.1529 19.8471 13.25 17.5 13.25ZM17.5 20.1562C16.0359 20.1562 14.8438 18.9641 14.8438 17.5C14.8438 16.0348 16.0359 14.8438 17.5 14.8438C18.9641 14.8438 20.1562 16.0348 20.1562 17.5C20.1562 18.9641 18.9641 20.1562 17.5 20.1562Z",
    fill: "#272830"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0688 13.4976C22.3815 13.4976 22.6351 13.244 22.6351 12.9313C22.6351 12.6185 22.3815 12.365 22.0688 12.365C21.756 12.365 21.5024 12.6185 21.5024 12.9313C21.5024 13.244 21.756 13.4976 22.0688 13.4976Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ee8de708ddbf507b0a8bc4de365c1e21.svg";
export { ForwardRef as ReactComponent };